<template>
  <div class="w-full max-w-5xl mx-auto p-3">
    <div v-if="!authChecked">

    </div>

    <!-- Loading state -->
    <div v-if="!authChecked || companies.isLoading" class="flex justify-center py-8">
      <the-loader>
        Please wait
      </the-loader>
    </div>


    <div v-else class="">
      <the-json-pretty :data="supabaseUser" title="Supabase User" />

      <h3 class="text-xl font-bold my-2">
        Your Companies
      </h3>

      <div v-if="companies.companies.length === 0">
        <p class="my-2">
          You don't have any companies yet.
        </p>
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
        <div v-for="company in companies.companies" :key="company.id">
          <nuxt-link :to="`/company/${company.public_id}`"
            class="card bg-base-200 hoverfloat w-full overflow-hidden">
            <div class="card-body p-3">
              <h3 class="card-title">{{ company.url }}</h3>
              <p class="text-xs">ID: {{ company.public_id }}</p>
            </div>
          </nuxt-link>
        </div>
      </div>

      <!-- <nuxt-link to="/onboard" class="btn btn-sm btn-primary my-2">
        Create a Company
      </nuxt-link> -->
      <the-json-pretty :data="companies" title="Companies" />

    </div>


  </div>
</template>


<script setup lang="ts">

import { until } from '@vueuse/core'

const supabaseUser = useSupabaseUser();
const authChecked = useAuthChecked();
const { $supabase } = useNuxtApp()
const companies = ref(
  {
    isLoading: true,
    companies: []
  }
);

// Add a route watcher
// const route = useRoute()
// watch(route, (newRoute) => {
//   console.log('Route changed:', newRoute)
// }, { deep: true })

onMounted(async() => {
  console.log("App mounted")

  // wait for the auth to be checked
  await until(() => authChecked.value)

})

// immediate watcher for supabaseUser
watch(supabaseUser, (newUser) => {
  console.log('Supabase user updated:', newUser)
  if(newUser) {
    getCompanies()
  }
}, { immediate: true })

async function getCompanies() {
  console.log('getCompanies, user: ', supabaseUser.value.id)

  companies.value.isLoading = true

  try {
    let session = await $supabase.auth.getSession()
  
    const response = await $fetch('/api/company', {
      method: 'GET',
      headers: {
        'Authorization': `${session.data.session?.access_token}`
      }
    })
    console.log('Companies data received:', response)

    companies.value.companies = response.data

    // if there's no companies, redirect to onboard
    if(companies.value.companies.length === 0) {
      navigateTo('/onboard')
    }

  } catch (error) {
    console.error('Error getting companies:', error)   
  } finally {
    companies.value.isLoading = false
  }
}

// Add this watch to see when companies change
watch(companies, (newCompanies) => {
  console.log('Companies updated:', newCompanies)
}, { deep: true })

</script>